import * as React from 'react';

/**
 * The full-color, brand-colored Rovo icon.
 *
 * Unlike {@link SvgRovo} (which is monochrome and uses `currentColor`), this
 * icon keeps its fixed brand colors and will not tint via the Lens `Icon`
 * `color` prop.
 */
export function SvgRovoBranded() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="0 0 20 20" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.41335 13.0597L3.41894 16.5206L2.22495 15.8317C1.52377 15.4274 1.08984 14.6775 1.08984 13.8695V6.13855C1.08984 5.32739 1.52122 4.58069 2.22449 4.17665L7.26074 1.271C7.24957 1.30236 7.23893 1.33393 7.22881 1.36569C7.13558 1.65499 7.08616 1.96065 7.08616 2.27308V10.004C7.08616 11.066 7.65184 12.0456 8.57369 12.5754L9.41335 13.0597Z"
          fill="#1868DB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.41336 13.0596L3.41895 16.5205L8.92472 19.697C9.61336 20.094 10.4608 20.101 11.1551 19.7181C11.1676 19.7084 11.181 19.6993 11.1952 19.6912C11.6899 19.406 12.0517 18.9486 12.2218 18.4203C12.291 18.2018 12.3276 17.9711 12.3276 17.7348V14.7402L9.41336 13.0596Z"
          fill="#6A9A23"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8978 4.16866L16.6136 3.42773L10.6191 6.88862L11.5494 7.42509C12.4714 7.9549 13.0367 8.9343 13.0367 9.99635V17.7273C13.0367 18.0402 12.9871 18.3462 12.8936 18.6359C12.8836 18.6673 12.8731 18.6984 12.8621 18.7294L17.8984 15.8237C18.6016 15.4197 19.033 14.673 19.033 13.8618V6.13088C19.033 5.32292 18.599 4.57291 17.8978 4.16866Z"
          fill="#AF59E1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6169 6.88852L7.79297 5.25995V2.26531C7.79297 2.02934 7.82947 1.79882 7.89856 1.58061C8.06839 1.05249 8.42961 0.595294 8.92378 0.309889L8.92528 0.309024C8.93945 0.300851 8.95293 0.291786 8.9655 0.282039C9.65979 -0.100921 10.5072 -0.0938861 11.1958 0.303145L16.6114 3.42763L10.6169 6.88852Z"
          fill="#FCA700"
        />
      </svg>
    </span>
  );
}
